import { createErrorResponse } from '@@/api/mock-server/utils.js'
import type { MockServer } from '@@/api/mock-server/server.js'

const VALID_TEST_CODE = '123456'

export function routes(server: MockServer) {
  server.post(
    '/pre-registration/:provet_token/send-otp/:appointment_token/:origin_token/',
    function (_, request) {
      const requestBody = JSON.parse(request.requestBody)
      const { contact_id } = requestBody

      if (contact_id === null || contact_id === undefined) {
        return createErrorResponse({
          status: 400,
          errors: [
            { code: 'invalid_contact', detail: 'Invalid contact method.' },
          ],
        })
      }

      return { success: true }
    },
  )

  server.post(
    '/pre-registration/:provet_token/verify-otp/:appointment_token',
    function (_, request) {
      const requestBody = JSON.parse(request.requestBody)
      const { code } = requestBody

      const { provet_token: provetToken, appointment_token: appointmentToken } =
        request.params

      if (!code || code !== VALID_TEST_CODE) {
        return createErrorResponse({
          status: 400,
          errors: [
            {
              code: 'otp_invalid',
              detail: 'The code you entered is incorrect.',
            },
          ],
        })
      }

      return {
        success: true,
        redirect_url: `/pre-registration/${provetToken}/register/${appointmentToken}/`,
      }
    },
  )
}
